var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "chat-index" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4", staticStyle: { "padding-right": "0px" } },
          [
            _c("div", { staticClass: "chat-sidebar" }, [
              _c("h3", [_vm._v("Chats ")]),
              _c("input", {
                attrs: { type: "text", placeholder: "Search conversations" }
              }),
              _c("div", { staticClass: "tabs" }, [
                _c(
                  "h6",
                  {
                    staticClass: "ongoing-con",
                    class: { actTab: _vm.activeTab === "unresolved" },
                    on: {
                      click: function($event) {
                        _vm.activeTab = "unresolved"
                      }
                    }
                  },
                  [_vm._v("Unresolved (" + _vm._s(_vm.unresolvedCount) + ")")]
                ),
                _c(
                  "h6",
                  {
                    staticClass: "ongoing-con",
                    class: { actTab: _vm.activeTab === "resolved" },
                    on: {
                      click: function($event) {
                        _vm.activeTab = "resolved"
                      }
                    }
                  },
                  [_vm._v("Resolved (" + _vm._s(_vm.resolvedCount) + ")")]
                )
              ]),
              _c("div", { staticClass: "clearfix" }),
              _c("div", { staticClass: "chat-box" }, [
                _vm.activeTab === "unresolved"
                  ? _c(
                      "div",
                      _vm._l(_vm.unresolvedUsers, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          chatUser.chat != "Admin chat"
                            ? _c(
                                "div",
                                {
                                  staticClass: "chatBox",
                                  class: {
                                    active:
                                      _vm.$route.params.userId == chatUser.id
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/sadmin/user-chat/" + chatUser.id
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-3",
                                            staticStyle: {
                                              "padding-right": "11px"
                                            }
                                          },
                                          [
                                            chatUser.image
                                              ? _c("img", {
                                                  attrs: { src: chatUser.image }
                                                })
                                              : _c("img", {
                                                  attrs: {
                                                    src: "/img/userChat.png"
                                                  }
                                                })
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-9",
                                            staticStyle: {
                                              "padding-left": "0px"
                                            }
                                          },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(chatUser.name))
                                            ]),
                                            _c("h6", [
                                              chatUser.isReceived == 1
                                                ? _c("span", {
                                                    staticClass: "userRep"
                                                  })
                                                : _c("img", {
                                                    staticStyle: {
                                                      "margin-right": "2px"
                                                    },
                                                    attrs: {
                                                      src: "/img/LeftReply.png"
                                                    }
                                                  }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(chatUser.chat) +
                                                  "\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.activeTab === "resolved"
                  ? _c(
                      "div",
                      _vm._l(_vm.resolvedUsers, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          _c(
                            "div",
                            {
                              staticClass: "chatBox",
                              class: {
                                active: _vm.$route.params.userId == chatUser.id
                              }
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/sadmin/user-chat/" + chatUser.id
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-3",
                                        staticStyle: { "padding-right": "11px" }
                                      },
                                      [
                                        chatUser.image
                                          ? _c("img", {
                                              attrs: { src: chatUser.image }
                                            })
                                          : _c("img", {
                                              attrs: {
                                                src: "/img/userChat.png"
                                              }
                                            })
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-9",
                                        staticStyle: { "padding-left": "0px" }
                                      },
                                      [
                                        _c("h5", [
                                          _vm._v(_vm._s(chatUser.name))
                                        ]),
                                        _c("h6", [
                                          chatUser.isReceived == 1
                                            ? _c("span", {
                                                staticClass: "userRep"
                                              })
                                            : _c("img", {
                                                staticStyle: {
                                                  "margin-right": "2px"
                                                },
                                                attrs: {
                                                  src: "/img/LeftReply.png"
                                                }
                                              }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(chatUser.chat) +
                                              "\n                  "
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.activeTab === "admin"
                  ? _c(
                      "div",
                      _vm._l(_vm.AdminData, function(chatUser) {
                        return _c("div", { key: chatUser.id }, [
                          chatUser.chat == "Admin chat"
                            ? _c(
                                "div",
                                {
                                  staticClass: "chatBox",
                                  class: {
                                    active:
                                      _vm.$route.params.userId == chatUser.id
                                  }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: "/sadmin/user-chat/" + chatUser.id
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-3",
                                            staticStyle: {
                                              "padding-right": "11px"
                                            }
                                          },
                                          [
                                            chatUser.image
                                              ? _c("img", {
                                                  attrs: { src: chatUser.image }
                                                })
                                              : _c("img", {
                                                  attrs: {
                                                    src: "/img/userChat.png"
                                                  }
                                                })
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-md-9",
                                            staticStyle: {
                                              "padding-left": "0px"
                                            }
                                          },
                                          [
                                            _c("h5", [
                                              _vm._v(_vm._s(chatUser.name))
                                            ]),
                                            _c("h6", [
                                              chatUser.isReceived == 1
                                                ? _c("span", {
                                                    staticClass: "userRep"
                                                  })
                                                : _c("img", {
                                                    staticStyle: {
                                                      "margin-right": "2px"
                                                    },
                                                    attrs: {
                                                      src: "/img/LeftReply.png"
                                                    }
                                                  }),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(chatUser.chat) +
                                                  "\n                  "
                                              )
                                            ])
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ])
          ]
        ),
        _vm._m(0)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-md-8", staticStyle: { "padding-left": "0px" } },
      [
        _c("div", { staticClass: "welcome-chat" }, [
          _c("img", { attrs: { src: "/img/pickl-logo.png" } }),
          _c("h4", [
            _vm._v(
              "Welcome to the Admin Chat Panel. Select a user to view and manage conversations."
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }